export default "__VITE_ASSET__COwBXPME__"